<template>
    <div>
        <avue-crud
                :option="option"
                :data="data"
                :page="page"
                @refresh-change="refreshChange"
                @search-change="searchChange"
                @row-save="store"
                @row-update="update"
                @row-del="del"
                @size-change="sizeChange"
                @current-change="currentChange"
                :upload-before="uploadBefore"
                ref="crud"
                v-model=form
        >
            <template slot-scope="scope" slot="menu">
                <el-button icon="el-icon-tickets" size="small" type="text"
                           @click.stop="handleInfoBusChangeOption(scope.row)">班车变更管理
                </el-button>
            </template>

            <template slot="noteForm">
                <avue-ueditor v-model="form.note" :upload="upload"></avue-ueditor>
            </template>
        </avue-crud>

        <el-dialog title="班车变更" :visible.sync="dialogInfoBusChangeVisible" :modal="true" width="80%" center>
            <InfoBusChange :defaultParams="{busId : this.busId }"></InfoBusChange>
        </el-dialog>
    </div>
</template>
<script>
  import curd from './Base/Crud'
  import InfoBusChange from './InfoBusChange'

  export default {
    mixins: [curd],
    components: {InfoBusChange},
    data() {
      return {
        form: {},
        dialogInfoBusChangeVisible: false,
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText: '新增线路', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '线路名',
              prop: 'title',
              span: 24,
              rules: [{
                type: 'string', required: true, message: '输入不正确', trigger: 'blur'
              }]
            }, {
              label: '班次',
              prop: 'cat_id',
              type: 'select',
              span: 24,
              props: {label: 'title', value: 'id'},
              dicUrl: this.config.baseURL + '/dic/bus/category',
              rules: [{
                required: true, message: '班次不能为空', trigger: 'blur'
              }]
            }, {
              label: '班车类型',
              prop: 'type',
              type: 'radio',
              dicData: [{'label': '上班', 'value': 0}, {'label': '下班', 'value': 1}],
              rules: [{
                required: true, message: '班车选择类型', trigger: 'blur'
              }]
            }, {
              label: '路线内容',
              prop: 'content',
              type: 'textarea',
              overHidden: true,
              align: 'left',
              span: 24,
              rules: [{
                required: true, message: '路线内容不能为空', trigger: 'blur'
              }]
            }, {
              label: '路线详情',
              prop: 'note',
              formslot: true,
              hide: true,
              align: 'left',
              span: 24,
              rules: [{
                required: true, message: '路线内容不能为空', trigger: 'blur'
              }]
            }, {
              label: '状态',
              prop: 'status',
              type: 'radio',
              dicData: [{'label': '上架', 'value': 1}, {'label': '下架', 'value': 2}],
              span: 24,
              rules: [{
                required: true, message: '状态不能为空', trigger: 'blur'
              }]
            }
          ]
        },
        busId: null
      }
    },
    methods: {
      // 更改记录列表
      handleInfoBusChangeOption(row) {
        this.dialogInfoBusChangeVisible = true;
        this.busId = row.id;
      }
    }
  }
</script>
